var React = require('react');

function LinkedinOutlineInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","d":"M4.356 17V6.419H1.1V17h3.256zm0-14.332C4.336 1.72 3.71 1 2.688 1 1.668 1 1 1.721 1 2.668c0 .926.648 1.668 1.649 1.668h.02c1.04 0 1.687-.742 1.687-1.668h0zM9.668 17v-6.029c0-.322.023-.645.118-.875.258-.645.846-1.313 1.833-1.313 1.292 0 2.103.737 2.103 2.188V17H17v-6.19c0-3.316-1.762-4.86-4.113-4.86-1.927 0-2.773 1.083-3.243 1.82l.024-1.415H6.396c.047 1.013 0 10.645 0 10.645h3.272z"}));
}

LinkedinOutlineInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = LinkedinOutlineInline;

LinkedinOutlineInline.default = LinkedinOutlineInline;
